import { DEFAULT_DATE_FORMAT, THEMES } from '@/shared/config';
import sunIcon from '@/shared/assets/sun-icon.svg';
import moonIcon from '@/shared/assets/moon-icon.svg';
import type {
  BaseAssetSelectItem,
  DateFormatSelectItem,
  ThemeSelectItem,
  TimeZoneSelectItem,
} from '../model';
import type {
  AccountAsset,
  BaseAsset,
  Country,
  LanguageSelectOption,
} from '@/shared/types';
import type { AssetsIcons } from '@/shared/api';
import { buildLanguageSelectOptions } from '@/shared/lib';
import { getCurrentTimezoneOffset } from '@/shared/utils';
import { useMemo } from 'react';

type Props = {
  countries: Country[];
  accountAssets: AccountAsset[];
  assetsIcons: AssetsIcons;
};

const useDisplaySettingsFormData = ({
  countries,
  accountAssets,
  assetsIcons,
}: Props) => {
  return useMemo(() => {
    const languages: LanguageSelectOption[] =
      buildLanguageSelectOptions(countries);

    const themes: ThemeSelectItem[] = THEMES
      // Temporary filter to hide dark theme
      .filter(theme => theme === 'light')
      .map(theme => ({
        value: theme,
        icon: theme === 'light' ? sunIcon : moonIcon,
      }));

    const dateFormats: DateFormatSelectItem[] = [
      {
        value: DEFAULT_DATE_FORMAT,
      },
    ];

    const assets: BaseAssetSelectItem[] = accountAssets.map(asset => ({
      value: asset.code as BaseAsset,
      name: asset.name,
      code: asset.code,
      icon: assetsIcons[asset.code] || undefined,
    }));

    const timeZones: TimeZoneSelectItem[] = [
      {
        value: getCurrentTimezoneOffset(),
        name: getCurrentTimezoneOffset(),
      },
    ];

    return { languages, themes, dateFormats, assets, timeZones };
  }, [countries, accountAssets, assetsIcons]);
};

export { useDisplaySettingsFormData };
